// extracted by mini-css-extract-plugin
export default {"container":"D3T5T","imgContainer":"JL_zm","logo":"Cg2dn"};